import { IApplicationState } from '../../types/redux';

export const selectTotalImagesCount = (state: IApplicationState): number => {
  return state.constructionProgressData.totalImagesCount;
};
